import { LifecycleStatus, ManagementType, PortfolioEngineAccount } from '@ndvr/portfolio-api';

import { parseNumberStr } from 'utils/number-utils';

export interface AccountsSummary {
    managedValue: number;
    heldAwayValue: number;
    boostedValue: number;
    boostedAccountCount: number;
    accountCount: number;
    totalCashValue: number;
    harvestableLossValue: number;
    boostedAccounts: PortfolioEngineAccount[];
}

const isBoosted = (account: PortfolioEngineAccount) => account.managementType === ManagementType.AUTOMATIC;

export const buildAccountsSummary = (
    accounts: PortfolioEngineAccount[],
    includedAccountGroupGUIDs: ReadonlySet<string>,
): AccountsSummary =>
    accounts.reduce<AccountsSummary>(
        (summary, account) => {
            if (
                account.lifecycleStatus === LifecycleStatus.ONBOARDING ||
                !includedAccountGroupGUIDs.has(account.accountGroupGUID)
            ) {
                return summary;
            }

            summary.accountCount += 1;
            if (account.externallyManaged) {
                summary.heldAwayValue += parseNumberStr(account.forecastStartingValue);
            } else {
                summary.managedValue += parseNumberStr(account.aum);
            }

            if (isBoosted(account)) {
                summary.boostedValue += parseNumberStr(account.aum);
                summary.boostedAccountCount += 1;
                summary.totalCashValue += parseNumberStr(account.cash);
                summary.boostedAccounts.push(account);

                if (account.hasTaxLossHarvesting) {
                    summary.harvestableLossValue += parseNumberStr(account.harvestableLoss);
                }
            }

            return summary;
        },
        {
            managedValue: 0,
            heldAwayValue: 0,
            boostedValue: 0,
            boostedAccountCount: 0,
            accountCount: 0,
            totalCashValue: 0,
            harvestableLossValue: 0,
            boostedAccounts: [],
        },
    );
